import type { ButtonHTMLAttributes, Ref } from 'react';

import BellIcon from '@cartwhl/ui/icons/BellIcon';
import { HEADER_ICON_BUTTON_CLASSNAME } from '@cartwhl/ui/layout/StudioShellHeader';

export default function NotificationButton({
  showIndicator = false,
  ref,
  className,
  type = 'button',
  ...props
}: {
  showIndicator?: boolean;
  ref?: Ref<HTMLButtonElement>;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      ref={ref}
      type={type}
      className={`${HEADER_ICON_BUTTON_CLASSNAME} relative overflow-visible ${className ?? ''}`}
      aria-label="Notifications"
      {...props}
    >
      <BellIcon className="text-primary h-7 w-7" />
      {showIndicator ? (
        <span
          className="bg-green h-3.25 w-3.25 pointer-events-none absolute -right-1 -top-1 shrink-0 rounded-full"
          aria-hidden
        />
      ) : null}
    </button>
  );
}
